import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["asChild"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Slot } from '../Slot';
import { jsx as _jsx } from "react/jsx-runtime";
const NODES = ['a', 'button', 'div', 'form', 'h2', 'h3', 'img', 'input', 'label', 'li', 'nav', 'ol', 'p', 'span', 'svg', 'ul'];
export const DomPrimitive = NODES.reduce((primitive, node) => {
  const Node = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
    const {
        asChild
      } = props,
      primitiveProps = _objectWithoutProperties(props, _excluded);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const Comp = asChild ? Slot : node;
    return /*#__PURE__*/_jsx(Comp, _objectSpread(_objectSpread({}, primitiveProps), {}, {
      ref: forwardedRef
    }));
  });
  Node.displayName = "Primitive.".concat(node);
  return _objectSpread(_objectSpread({}, primitive), {}, {
    [node]: Node
  });
}, {});